import { jsx as _jsx } from "react/jsx-runtime";
import { ThorView } from '@aviv-dxp/react-thor';
import { getPageViewTrackingData } from '@utils/ga4tracking';
const TrackPageView = ({ mediumParam }) => {
    const viewPageData = {
        av_pagetitle: 'classified_acquisition_funnel_dispatch_page',
        av_medium: mediumParam,
    };
    return _jsx(ThorView, { viewProps: getPageViewTrackingData(viewPageData) });
};
export default TrackPageView;
